<template>
  <section> 
    <div id="chart-container" width="500px"></div>
    <div>最大队列：{{maxQueueCount}}</div>
  </section>
</template>

<style>
  #chart-container{
    position:absolute;
    width: 80%;
    height: 100%;
  }
</style>

<script>
import echarts from 'echarts'
export default {
  name: 'mqMonitor',
  data() {
    return {
      maxQueueCount: 0,
      tableheight: (window.innerHeight - 220) + 'px'
    }
  },
  methods: {
    loadChart: function() {
      var dom = document.getElementById('chart-container')
      var myChart = echarts.init(dom)
      // var app = {}
      var option = null
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        legend: {
          data: ['ActionLog队列']
        },
        toolbox: {
          show: true,
          feature: {
            dataView: {readOnly: false},
            restore: {},
            saveAsImage: {}
          }
        },
        dataZoom: {
          show: false,
          start: 0,
          end: 100
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: (function () {
              var now = new Date()
              var res = []
              var len = 100
              while (len--) {
                res.unshift(now.Format('hh:mm:ss'))
                now = new Date(now - 2000)
              }
              return res
            })()
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '队列长度',
            max: 100,
            min: 0,
            boundaryGap: [0.2, 0.2]
          }
        ],
        series: [
          {
            name: 'ActionLog队列',
            type: 'line',
            data: (function () {
              var res = []
              var len = 0
              while (len < 100) {
                res.push(0)
                len++
              }
              return res
            })()
          }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option, true)
      }

      var refreshChart = function (num) {
        let axisData = (new Date()).Format('hh:mm:ss')

        var data0 = option.series[0].data
        data0.shift()
        data0.push(num)

        option.xAxis[0].data.shift()
        option.xAxis[0].data.push(axisData)
        option.yAxis[0].max = data0.max

        myChart.setOption(option)
      }

      var socket
      var uri = 'ws://' + window.location.host + '/ws?identifier=' + this.getguid()
      socket = new WebSocket(uri)
      socket.onopen = function (e) {
        console.log('open');
        var command = {
          CommandName:'ActionLogMQMonitorCommand'
        }
        let msg = "@"+JSON.stringify(command)
        socket.send(msg)
      }
      socket.onclose = function (e) { console.log('closed') }
      socket.onmessage = (e) => {        
        return (() => {
          if (e.data.indexOf("sys::ping") == -1) {
            if (e.data > this.maxQueueCount) {
              this.maxQueueCount = e.data
            }
            refreshChart(e.data)
          }
        })()
      }
      socket.onerror = function (e) { console.log('Error: ' + e.data) }
      }
    ,
    getguid: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableheight = (window.innerHeight - 220) + 'px'
      })()
    }
    setTimeout(this.loadChart(), 1000)
  }
}
</script>